module.exports = __webpack_public_path__ + "img/73_M15_question_authority.c4e20617.jpg";